import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UserService } from '../../_services/user.service';
import { Meta } from '@angular/platform-browser';
import { MediaMatcher } from '@angular/cdk/layout';
import { Subscription } from 'rxjs';
import { MetaService } from 'ng2-meta';
import { AngularFirestore } from 'angularfire2/firestore';
import { map } from 'rxjs/operators';
import { DATABASE_PROVIDERS } from 'angularfire2/database';
import { ScrollService } from '../../_services/scroll.service';

@Component({
  selector: 'app-post-profile',
  templateUrl: './post-profile.component.html',
  styleUrls: ['./post-profile.component.css']
})
export class PostProfileComponent implements OnInit {

  sub: any;
  post: any;
  user: any;
  userId: string;
  mobileQuery: any;
  visible: any;
  uniqueName: string;
  userName: any;
  seoName: any;
  firstName: string;
  lastName: string;
  private _mobileQueryListener: () => void;
  private subscription: Subscription = new Subscription();
  constructor(
    private route: ActivatedRoute,
    private meta: Meta,
    private userService: UserService,
    private media: MediaMatcher,
    private cd: ChangeDetectorRef,
    private afs: AngularFirestore,
    private scrollService: ScrollService,
    private metaService: MetaService
  ) {

    this.userId = this.userService.getUid();
    this.meta.addTag(
      { name: 'twitter:card', content: 'summary_large_image' }
    );
    this.mobileQuery = this.media.matchMedia('(max-width: 1024px)');
    this._mobileQueryListener = () => this.cd.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
  }

  ngOnDestroy() {
    this.mobileQuery.removeListener(this._mobileQueryListener);
    this.subscription.unsubscribe();
    this.sub.unsubscribe();
  }

  ngOnInit() {
    this.sub = this.scrollService.isScroll.subscribe(a => {
      if (document.querySelector(".perfect-scrollbar").scrollTop > 620) {
        this.visible = true;

      }
      else {
        this.visible = false;

      }
    })



    this.subscription.add(this.userService.getUser().subscribe(user => {
      this.user = user
    }));
    let postKey = this.route.snapshot.params['postKey'];

    this.subscription.add(this.afs.collection('posts').doc(postKey).snapshotChanges().pipe(map(data => {

      return {
        ...data.payload.data(),
        id: data.payload.id
      }
    })).subscribe(snap => {
      this.post = snap;

      this.uniqueName = snap['rating'].uniqueName;
      this.userName = snap['author'].username;
      this.firstName = snap['author'].firstname;
      this.lastName = snap['author'].lastname;


      this.metaService.setTitle('(' + this.uniqueName + ')' + ' ' + ' ile ilgili' + ' ' + this.firstName + ' ' + this.lastName + ' ' + '(' + '@' + this.userName + ')' + ' ' + 'Kullanıcı Yorumu | bigadvice.com');
      this.metaService.setTag('description', "Marka ürün ve hizmetleriyle ilgili kullanıcı yorumları ve müşteri görüşleri bigadvice'ta buluşuyor.Burada sen de müşteri deneyimlerini herkesle paylaşabilir, diğer kullanıcıların yorumlarından ilham alabilirsin. ");



    }))
    // this.afs.collection('posts').doc(postKey).ref.get().then(snap => {
    //   if (snap.data()) {
    //     this.post = snap.data();
    //     console.log(snap.id)
    //     Object.assign(this.post, { id: postKey });
    //     console.log(this.post)

    //     this.uniqueName = snap.data().rating.uniqueName;
    //     this.userName = snap.data().author.username;
    //     this.firstName = snap.data().author.firstname;
    //     this.lastName = snap.data().author.lastname;

    //   }
    // })


  }
}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/pages/post-profile/post-profile.component.ts